import React, { useEffect, useRef, useState } from "react"
import * as styles from "./styles.module.scss"

export interface ProgressBarProps {
  currentQuestionId: string
  questionKeys: string[]
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  currentQuestionId,
  questionKeys,
}) => {
  const wrapper = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState<boolean>(true)
  const [barWidth, setBarWidth] = useState<number>(0)

  useEffect(() => {
    if (!questionKeys.includes(currentQuestionId)) setIsVisible(false)

    const index = questionKeys.indexOf(currentQuestionId)
    const screenWidth = wrapper?.current?.getBoundingClientRect().width ?? 0
    const width = (screenWidth / questionKeys.length) * index
    setBarWidth(width)
  }, [currentQuestionId, questionKeys])

  return (
    <div className={styles.progressBar} data-visible={isVisible} ref={wrapper}>
      <div className={styles.progress} style={{ width: barWidth }}></div>
    </div>
  )
}

export default ProgressBar
